// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UYk1aM8zUio6F7s-5p7nrw\\=\\={display:flex;justify-content:center;margin-bottom:var(--xds-spacing-e)}.UYk1aM8zUio6F7s-5p7nrw\\=\\= img{pointer-events:none}", "",{"version":3,"sources":["webpack://./src/shared/components/Tutorial/tutorials/OCFTutorial/components/OCFTutorialPopup/OCFTutorialPopup.module.scss"],"names":[],"mappings":"AAAA,4BACE,YAAA,CACA,sBAAA,CACA,kCAAA,CACA,gCACE,mBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popupImageContainer": "UYk1aM8zUio6F7s-5p7nrw=="
};
export default ___CSS_LOADER_EXPORT___;
